// Per-table column-type cache of the query console (`{ colName: typeName }`), filled
// lazily from `SHOW COLUMNS FROM <table>`. The console uses it only for a reply
// without its own column header (B607).
//
// B1691: one table name can have a different schema in each database and branch.
// The key is the scope (database and branch) at send time plus the table name. A
// switch then never serves the types of the old database. An answer that arrives
// after a switch fills the entry of the scope that it was sent in.

export function tableFromSql(sql) {
  const m = /\bFROM\s+([A-Za-z_][A-Za-z0-9_]*)/i.exec(sql);
  return m ? m[1] : null;
}

// `sql(text)` runs a statement; `scope()` returns the current database and branch.
export function createColTypeCache({ sql, scope }) {
  const cache = new Map();
  async function colTypesForResult(query, columns) {
    const table = tableFromSql(query);
    if (!table) return null;
    const key = `${scope()}\u0000${table}`;
    let map = cache.get(key);
    if (!map) {
      try {
        const r = await sql(`SHOW COLUMNS FROM ${table}`);
        if (r?.type !== 'rows') return null;
        map = {};
        for (const [col, type] of r.data) map[col] = type;
        cache.set(key, map);
      } catch { return null; }
    }
    return columns.map(c => map[c] || null);
  }
  // DDL changes a schema: drop every entry.
  return { colTypesForResult, clear: () => cache.clear() };
}
